var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.list),function(item){return _c('MoleculeCheckbox',{key:item.value,attrs:{"value":item.value,"type":"checkbox","label":item.label,"name":_vm.name,"checked":_vm.value == item.value},on:{"input":_vm.select}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }